// src/data/sampleTrades.js
import { v4 as uuidv4 } from 'uuid';

export const SAMPLE_TRADES = [
  {
    id: uuidv4(),
    date: "2026-04-25",
    pair: "EUR/USD",
    session: "London",
    direction: "Buy",
    entryPrice: 1.0850,
    stopLoss: 1.0820,
    takeProfit: 1.0910,
    riskAmount: 50,
    pnl: 100,
    result: "Win",
    rrAchieved: 2.0,
    screenshotLink: "",
    notes: "Clean breakout above Asian range. Waited for retest.",
    mistakeMade: "None",
    followedRules: true,
    emotionBefore: "Calm",
    emotionAfter: "Confident"
  },
  {
    id: uuidv4(),
    date: "2026-04-24",
    pair: "GBP/USD",
    session: "London",
    direction: "Sell",
    entryPrice: 1.2650,
    stopLoss: 1.2690,
    takeProfit: 1.2560,
    riskAmount: 50,
    pnl: -50,
    result: "Loss",
    rrAchieved: -1.0,
    screenshotLink: "",
    notes: "Entered early, didn't wait for confirmation.",
    mistakeMade: "Impatience",
    followedRules: false,
    emotionBefore: "Excited",
    emotionAfter: "Frustrated"
  },
  {
    id: uuidv4(),
    date: "2026-04-23",
    pair: "XAU/USD",
    session: "New York",
    direction: "Buy",
    entryPrice: 2325.50,
    stopLoss: 2318.00,
    takeProfit: 2348.00,
    riskAmount: 75,
    pnl: 225,
    result: "Win",
    rrAchieved: 3.0,
    screenshotLink: "",
    notes: "Perfect setup. OB + liquidity sweep + confirmation.",
    mistakeMade: "None",
    followedRules: true,
    emotionBefore: "Calm",
    emotionAfter: "Satisfied"
  },
  {
    id: uuidv4(),
    date: "2026-04-22",
    pair: "NAS100",
    session: "New York",
    direction: "Sell",
    entryPrice: 17800,
    stopLoss: 17850,
    takeProfit: 17700,
    riskAmount: 50,
    pnl: 0,
    result: "Breakeven",
    rrAchieved: 0,
    screenshotLink: "",
    notes: "Moved SL to entry after 1:1. Good discipline.",
    mistakeMade: "None",
    followedRules: true,
    emotionBefore: "Neutral",
    emotionAfter: "Neutral"
  },
  {
    id: uuidv4(),
    date: "2026-04-21",
    pair: "EUR/USD",
    session: "London",
    direction: "Sell",
    entryPrice: 1.0920,
    stopLoss: 1.0890,
    takeProfit: 1.0860,
    riskAmount: 50,
    pnl: -75,
    result: "Loss",
    rrAchieved: -1.5,
    screenshotLink: "",
    notes: "Revenge traded after earlier loss. Broke rule.",
    mistakeMade: "Revenge Trading",
    followedRules: false,
    emotionBefore: "Angry",
    emotionAfter: "Regretful"
  }
];
